import axios from "axios";
import { API_BASE_URL, API_TIMEOUT } from "../config/apiConfig";
import { RefreshToken } from "../api/AuthApi";

let refreshTokenAttempts = 0;
const MAX_REFRESH_TOKEN_ATTEMPTS = 1;

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: API_TIMEOUT,
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Guard: CORS / network errors have no response object at all.
    // Treat them as non-retryable and propagate immediately.
    if (!error.response) {
      return Promise.reject(error);
    }

    if (error.response.status === 401) {
      const publicRoutes = ["/get-started"];
      const currentPath = window.location.pathname;
      const isPublicRoute = publicRoutes.some((route) =>
        currentPath.startsWith(route),
      );

      try {
        if (refreshTokenAttempts < MAX_REFRESH_TOKEN_ATTEMPTS) {
          refreshTokenAttempts++;
          await RefreshToken();
          refreshTokenAttempts = 0;

          // Retry with the original axiosInstance so withCredentials is kept.
          return axiosInstance(error.config);
        } else {
          localStorage.removeItem("userProfile");

          if (!isPublicRoute) {
            window.location.href = "/";
          }

          return Promise.reject(error);
        }
      } catch (refreshError) {
        localStorage.removeItem("userProfile");

        if (!isPublicRoute) {
          window.location.href = "/";
        }

        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
